import React from 'react'
import { Link } from 'react-router'

class Footer extends React.Component { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <footer className="bt-1">
        <section className="section pb-3">
          <div className="container">
            <div className="row">
              <div className="col-6 col-md-4">
                <h5 className="text-uppercase"><a href="http://softin.com.br">Softin Sistemas</a></h5>
                <nav>
                  <ul className="pl-0" style={{ listStyle: 'none', lineHeight: 2 }}>
                    <li><a href="http://softin.com.br">Home</a></li>
                    <li><a href="http://softin.com.br/empresa">Empresa</a></li>
                    <li><a href="http://blog.softin.com.br/posts/">Blog</a></li>
                    <li><a href="http://softin.com.br/suporte">Suporte</a></li>
                    <li><a href="http://softin.com.br/contato">Contato</a></li>
                    <li><a href="http://indique.softin.com.br/">Indique Parceiros</a></li>
                  </ul>
                </nav>
              </div>
              <div className="col-6 col-md-4">
                <nav>
                  <h5 className="text-uppercase"><a href="http://softin.com.br/gravittem/">Gravíttem</a></h5>
                  <ul className="pl-0" style={{ listStyle: 'none', lineHeight: 2 }}>
                    <li><a href="http://softin.com.br/gravittem/netco">netco</a></li>
                    <li><a href="http://softin.com.br/gravittem/store">store</a></li>
                    <li><a href="http://softin.com.br/gravittem/tax">tax</a></li>
                    <li><a href="http://softin.com.br/gravittem/master">master</a></li>
                    <li><a href="http://softin.com.br/gravittem/fieldforce">fieldforce</a></li>
                    <li><a href="http://softin.com.br/gravittem/contract">contract</a></li>
                    <li><a href="http://softin.com.br/gravittem/customer">customer</a></li>
                    <li><a href="http://softin.com.br/gravittem/distributor">distributor</a></li>
                  </ul>
                </nav>
              </div>
              <div className="col-6 col-md-4">
                <nav>
                  <h5 className="text-uppercase"><a href="http://softin.com.br/segmentos/">Segmentos</a></h5>
                  <ul className="pl-0" style={{ listStyle: 'none', lineHeight: 2 }}>
                    <li><a href="http://softin.com.br/segmentos/assistencias-tecnicas">Assistências técnicas</a></li>
                    <li><a href="http://softin.com.br/segmentos/distribuidores-de-pecas">Distribuidores de peças</a></li>
                    <li><a href="http://softin.com.br/segmentos/mobiliario-urbano">Mobiliário urbano</a></li>
                    <li><a href="http://softin.com.br/segmentos/graficas">Gráficas</a></li>
                    <li><a href="http://softin.com.br/segmentos/equipamentos-hospitalares">Equipamentos hospitalares</a></li>
                    <li><a href="http://softin.com.br/segmentos/elevadores">Elevadores</a></li>
                    <li><a href="http://softin.com.br/segmentos/oficina-automotiva">Oficinas automotivas</a></li>
                    <li><a href="http://softin.com.br/segmentos/manutencao-industrial">Manutenção industrial</a></li>
                  </ul>
                </nav>
              </div>
              <div className="col-12 col-md-6">
                <nav>
                  <h5 className="text-uppercase"><a href="http://softin.com.br/contato">Contato</a></h5>
                </nav>
                <span><i className="material-icons text-blue" style={{ fontSize: '18px' }}>call</i>(47) 3437-3312</span>
                <br />
                <span><img src={require('../assets/img/logos/whatsapp.png')} alt="whatsapp" />(47) 99134-2776</span>
                <br />
                <span><a href="mailto:contato@softin.com.br">contato@softin.com.br</a></span>
                <p>
                  Softin Sistemas Ltda<br />
                  Rua Iririu, 847<br />
                  Bairro Saguaçu<br />
                  Joinville – SC<br />
                  89221-515
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-between" style={{ width: 144 }}>
              <a href="https://www.facebook.com/SoftinSistemas"><img className="hover-effect" alt="facebook" src={require('../assets/img/logos/fb.svg')} width="24" /></a>
              <a href="https://twitter.com/Softin_Sistemas"><img className="hover-effect" alt="twitter" src={require('../assets/img/logos/tw.svg')} width="24" /></a>
              <a href="https://www.linkedin.com/company/softin-sistemas"><img className="hover-effect" alt="linkedin" src={require('../assets/img/logos/ln.svg')} width="24" /></a>
              <a href="https://www.instagram.com/softinsistemas/"><img className="hover-effect" alt="linkedin" src={require('../assets/img/logos/in.svg')} width="24" /></a>
              <a href="https://www.youtube.com/channel/UCR2dDQZLrjnJPFE7po8DaHA"><img className="hover-effect" alt="linkedin" src={require('../assets/img/logos/youtube.png')} width="30" /></a>
            </div>
            <small className="d-block mt-3">Softin Sistemas – ©2018 Todos os direitos reservados - <Link to="/Regulation"> <small>Regulamento de indicações</small></Link></small>
          </div>
        </section>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./client/components/Footer.js